import React, { useMemo } from "react";
import styled from "@emotion/styled";
import CommonUtils from "services/common/utils";
import ParkkiTheme from "themes/ParkkiTheme";

import StatTypes from "types/StatTypes";

import InfosTooltip from "components/InfosTooltip";
import StatsContainer from "components/StatsContainer";

const Label = styled.div`
  font-size: 10px;
  width: 65%;
  text-align: center;
`;

const SubLabel = styled.div`
  font-size: 8px;
  margin-top: 4px;
  margin-bottom: 6px;
`;

const Normal = styled.div`
  display: flex;
  align-items: baseline;
  text-align: center;
  font-size: 21px;
  margin: 4px;
  color: ${(props) => props.color};
`;

const ArrowImage = styled.img`
  width: 12px;
  height: auto;
  margin-right: 8px;
`;

type Props = { data: StatTypes; numberOfSection: number };

function NormalStatsWithoutLabel({
  data,
  numberOfSection,
}: Props): JSX.Element {
  const normalColor = useMemo(() => {
    switch (
      typeof data?.type?.retrieveColor === "function"
        ? data?.type?.retrieveColor(data?.value)
        : ""
    ) {
      case "green":
        return ParkkiTheme.colors.green;
      case "red":
        return ParkkiTheme.colors.red;
      default:
        return "black";
    }
  }, [data?.value, data?.type]);

  const Symbol = useMemo(() => {
    const symbol = data?.type?.symbol;
    const way = data?.type?.way ? data?.type?.way(data?.value) : "";
    const color = data?.type?.retrieveColor
      ? data?.type?.retrieveColor(data?.value)
      : "";

    if (symbol === "arrow") {
      switch (way) {
        case 1:
          return (
            <ArrowImage
              src={require(`images/stats-row-arrow-up-${color}.png`)}
            />
          );
        case -1:
          return (
            <ArrowImage
              src={require(`images/stats-row-arrow-down-${color}.png`)}
            />
          );
        default:
          return "=";
      }
    } else if (symbol === "sign") {
      switch (way) {
        case 1:
          return "+";
        case -1:
          return "-";
        default:
          return "=";
      }
    } else {
      return "=";
    }
  }, [data?.value, data?.type]);

  const value = useMemo(() => {
    return data?.type?.retrieveNormal
      ? data?.type?.retrieveNormal(data?.value)
      : data?.value;
  }, [data?.value, data?.type]);

  return (
    <StatsContainer
      disabled={value === null || value === undefined}
      headerColor={data?.headerColor}
      order={data?.type?.order}
      numberOfSection={numberOfSection}
    >
      <>
        {data?.toggle ? (
          <Normal color={normalColor}>
            {Symbol}{" "}
            {value !== null && value !== undefined
              ? CommonUtils.formatNumber(value)
              : "-"}{" "}
            {data?.type?.unity}
            {data?.infos ? <InfosTooltip infos={data?.infos} /> : null}
          </Normal>
        ) : null}
        <SubLabel>{data?.subLabel}</SubLabel>
        <Label>{(data?.label || "").toUpperCase()}</Label>
      </>
    </StatsContainer>
  );
}

export default NormalStatsWithoutLabel;
